import { SpinnerIcon } from "@phosphor-icons/react";
import { classed } from "@tw-classed/core";
import { withClassName } from "../../helpers";

const classedLoader = classed("animate-spin");

export const getLoaderClass = withClassName((props: LoaderProps) => classedLoader(props));

type LoaderProps = {
  className?: string;
};

export const Loader = ({ className }: LoaderProps) => <SpinnerIcon className={getLoaderClass({ className })} />;
